import { useSwitchChain, useAccount } from 'wagmi'
import { UNI2_CHAIN_ID } from '@/constants/addresses'

export function useNetworkSwitch() {
  const { chainId } = useAccount()
  const { switchChain, isPending, error } = useSwitchChain()

  const isCorrectNetwork = chainId === UNI2_CHAIN_ID

  const switchToUni2 = () => {
    if (!isCorrectNetwork) {
      switchChain({ chainId: UNI2_CHAIN_ID })
    }
  }

  return {
    isCorrectNetwork,
    currentChainId: chainId,
    switchToUni2,
    isPending,
    error,
  }
}
